import React from 'react';
import {
    ModalErrorBoundary,
    ViewErrorBoundary,
} from './components/ErrorBoundary';
import { ReportEventContent } from './components/ReportEventContent';
import { ReportEventRenderer } from './components/ReportEventRenderer';
import { OverlayProvider, PaginationProvider, UserProvider } from './context';
import { Pages } from './types';

interface ReportThisEventProps {
    /**
     * The ID of the organizer associated
     * with the event to be reported
     */
    organizerId?: string;
    /**
     * Boolean controlling the visibility
     * status of the overlay. The consuming
     * application will need to handle managing
     * this state.
     */
    isVisible: boolean;
    /**
     * Optional callback triggered
     * when the widget  is closed
     */
    onClose?: () => void;
    /**
     * DEFAULT: 'root'
     *
     * Id of the dom node that this widget should
     * mount onto.
     *
     * Since it is an overlay, it is recommended
     * to use something close to the root of the
     * DOM tree
     */
    domNodeId?: string;
    /**
     * DOM Element to mount the modal into.
     *
     * If passed in, will take precedence over
     * the domNodeId argument and render into the
     * element directly.
     *
     * Since it is an overlay, it is recommended
     * to use something close to the root of the
     * DOM tree
     */
    domNode?: Element;
    /**
     * Optional parameter with the event id.
     *
     * If it exists, the email will contain information
     * about the event.
     */
    eventId: string;
    /**
     * Optional but recommended boolean determining
     * if the user is currently logged in
     *
     * If true, will fetch the user information
     * and prefill the email and name fields of the
     * form.
     */
    isAuthenticated?: boolean;

    country: string;

    id?: string;
    eventName: string;
    eventUrl: string;
    helpCenterLanguage: string;
}

export const ReportThisEvent: React.FC<ReportThisEventProps> = (
    props: ReportThisEventProps,
) => {
    const {
        domNode,
        isVisible,
        onClose,
        domNodeId = 'root',
        eventId,
        country,
        eventName,
        eventUrl,
        helpCenterLanguage,
    } = props;
    return (
        <ModalErrorBoundary>
            <PaginationProvider page={Pages.intro}>
                <OverlayProvider
                    isVisible={isVisible}
                    onClose={onClose}
                >
                    <ReportEventRenderer
                        domNodeId={domNodeId}
                        domNode={domNode}
                    >
                        <ViewErrorBoundary>
                            <UserProvider
                                isAuthenticated={props.isAuthenticated}
                            >
                                <ReportEventContent
                                    eventId={eventId}
                                    country={country}
                                    eventName={eventName}
                                    eventUrl={eventUrl}
                                    helpCenterLanguage={helpCenterLanguage}
                                />
                            </UserProvider>
                        </ViewErrorBoundary>
                    </ReportEventRenderer>
                </OverlayProvider>
            </PaginationProvider>
        </ModalErrorBoundary>
    );
};
